import { render } from "./SearchView.vue?vue&type=template&id=6b08de9c"
import script from "./SearchView.vue?vue&type=script&lang=js"
export * from "./SearchView.vue?vue&type=script&lang=js"

import "./SearchView.vue?vue&type=style&index=0&id=6b08de9c&lang=css"

import exportComponent from "/Users/matt/Dev/convict-memorial-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__